import { useRef } from 'react';
import _ from 'lodash';

/**
 * Keeps a stable reference for a value that only ever differs structurally. Replaces the stored reference only when a deep equality check fails, so dependency arrays built from it stay stable across renders.
 *
 * @param value - Value to memoize by deep comparison.
 * @returns The stored value, unchanged until a deep comparison detects a difference.
 */
const useDeepCompareMemoize = <T>(value: T) => {
  const ref = useRef(value);
  if (!_.isEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
};

export default useDeepCompareMemoize;
